import { useContext } from "react";
import { ApiContext } from "../contexts/ApiContext";
import { QueryCallbacks } from "../shared/interfaces/ReactQuery";
import { useQuery } from "react-query";
import { Result } from "../shared/interfaces/Result";
import { ResultListRequestType } from "../shared/apiHandlers/ResultsAPIs";
import { PagedData } from "../shared/interfaces/ResultsAPIInterfaces";
import { DataTablePFSEvent } from "primereact/datatable";

export function usePagedResultsList(
  lazyState: DataTablePFSEvent,
  resultType?: ResultListRequestType,
  companyId?: number,
  siteId?: number,
  callbacks?: QueryCallbacks<PagedData<Result[]>>,
) {
  const apiContext = useContext(ApiContext);

  return useQuery({
    queryKey: ["pagedResultsList", lazyState, resultType, companyId, siteId],
    queryFn: async () => {
      if (lazyState && resultType)
        return await apiContext.resultsApis.getPagedResultsList(lazyState, resultType, companyId, siteId);
    },
    onSuccess: callbacks?.onSuccess,
    onError: callbacks?.onError,
  });
}
